import { Badge, Chip } from '@mui/material';
import { useState } from 'react';
import CommentIcon from '@mui/icons-material/Message';

// ステータスラベルコンポーネント
function StatusLableComponent(props) {
  const STATUS_LIST = [
    { id: '新規', label: '新規', color: '#172b4d', background: '#C4CAE9' },
    { id: '作成中', label: '作成中', color: '#172b4d', background: '#C4CAE9' },
    {
      id: '承認待ち',
      label: '申請中',
      color: '#ffffff',
      background: '#636363',
      badgeColor: 'success',
    },
    { id: '承認済み', label: '承認', color: '#ffffff', background: '#1976D2', badgeColor: 'error' },
    { id: '承認却下', label: '却下', color: '#ffffff', background: '#dc3545', badgeColor: 'info' },
    { id: '小工事', label: '小工事', color: '#000000', background: '#ffe4e1', badgeColor: 'info' },
    { id: '契約済', label: '契約', color: '#ffffff', background: '#3FBF31' },
    { id: '発注なし', label: '発注なし', color: '#7d310e', background: '#f7c2aa' },
    { id: 'マイナス', label: 'マイナス', color: '#feeeed', background: '#f85a51' },
  ];
  const status = STATUS_LIST.find((s) => s.id == props.status);
  const badgeContent = props.badgeContent;
  const hidden = props.hidden;
  const className = props.className;
  const rejectReason = props.rejectReason;
  const onClickRejectComment = () => {
    props.openRejectCommentModal(rejectReason);
  };

  // クリック処理
  const handleOnClick = () => {
    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <Badge
      className={className}
      color={status?.badgeColor}
      overlap={props.isUnread ? 'circular' : 'rectangular'}
      badgeContent={badgeContent}
      hidden={hidden}
      variant={badgeContent?.length ? 'standard' : props.isUnread ? 'dot' : ''}
      sx={props.isUnread ? { '& .MuiBadge-badge': { height: 10, minWidth: 10 } } : {}}
    >
      <Chip
        label={status?.label}
        deleteIcon={rejectReason ? <CommentIcon /> : null}
        style={{ minWidth: '62px', color: status?.color, background: status?.background }}
        size="small"
        onDelete={rejectReason ? onClickRejectComment : null}
        onClick={props.onClick ? () => handleOnClick('') : null}
      />
    </Badge>
  );
}

export default StatusLableComponent;
